import script from "./newsOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./newsOverview.vue?vue&type=script&setup=true&lang=js"

import "./newsOverview.vue?vue&type=style&index=0&id=60f942e8&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f942e8"]])

export default __exports__